module.exports = __webpack_public_path__ + "img/nav-recovery.5f7a0e6a.svg";